import { Component, OnInit, Inject, ElementRef, ViewChild, AfterContentInit, DoCheck, AfterViewInit, AfterViewChecked, AfterContentChecked } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { User, Role, Module } from '../../../pages/users/user.model';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { SettingsService } from '../../../pages/settings/settings.service';
import { PaymentService } from "../../services/payment.service";

import * as moment from 'moment';

@Component({
  selector: 'app-confirm-pay-dialog',
  templateUrl: './confirm-pay-dialog.component.html',
  styleUrls: ['./confirm-pay-dialog.component.scss'],
  providers: [ SettingsService, PaymentService ]
})
export class ConfirmPayDialogComponent implements OnInit{

  public user: User;
  public titleButton: string;
  public cxc: any;
  public clicked: boolean = false;
  public isBlocked: boolean = false;
  public invoice = new FormControl(null, [Validators.required]);
  public fcRunway = new FormControl("2", [Validators.required]);
  public rfc = new FormControl(null);
  public business_name = new FormControl(null);

  constructor(
            public settingsService: SettingsService,
            public paymentService: PaymentService,
            public dialogRef: MatDialogRef<ConfirmPayDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: any,
            public fb: FormBuilder,
            private toastr: ToastrService
        ) {
          
          //console.log(data);
          this.titleButton = data.titleButton;
          this.user = AuthService.getUser();
          this.cxc = this.data.cxc;
  }

  ngOnInit(){
  }


  generatePaymentLeague(){
    if(this.invoice.value == null && this.user.business_id == 1){
      this.toastr.error("Indique SI requiere o NO factura");
      return;
    }
    if((this.invoice.value == '1' && (this.isNullOrWhitespace(this.rfc.value) || this.isNullOrWhitespace(this.business_name.value))) && this.user.business_id == 1){
      this.toastr.error("Capture RFC y Razon social para continuar");
      return;
    }

    //console.log(moment().format('YYYYMMDDhhmmss'));
    //return;

    if(this.cxc){
      this.clicked = true;
      this.isBlocked = true;
      const data = {
        matricula: this.user.registration,
        amount: this.cxc.monto,
        transaction: (this.user.business_id == 3 ? '' : this.cxc.inst_clave) + moment().format('YYYYMMDDhhmmss') + this.cxc.cuenta_cobrar_id,
        who: 'studentportal',
        curp: this.user.curp,
        student_name: this.user.name + ' ' + this.user.lastname,
        concept: this.data.concept,
        description: this.cxc.descripcion + ' - ' + this.cxc.ciclo_id,
        email: this.user.email,
        id_runway: this.fcRunway.value,
        want_invoice: this.invoice.value,
        rfc: this.invoice.value == '1' ? this.rfc.value: null,
        business_name: this.invoice.value == '1' ? this.business_name.value : null,
        business_id: this.user.business_id,
        inst_id: this.cxc.inst_id,
      }

      if(this.fcRunway.value == "2"){
        this.paymentService.generatePaymentLeague(data).subscribe(result => {
          console.log(result);
          var xmlDoc = null;
          var parser = new DOMParser();
          xmlDoc = parser.parseFromString(result, "text/xml").getElementsByTagName('P_RESPONSE')[0];
          var cdResponse = xmlDoc.getElementsByTagName('cd_response')[0].textContent;
          var nbResponse = xmlDoc.getElementsByTagName('nb_response')[0].textContent;
          var nburl = xmlDoc.getElementsByTagName('nb_url')[0].textContent;
  
          if (!nbResponse) {
              window.location.href = nburl;
          } else {
              //confirm(nbResponse);
              this.isBlocked = false;
              console.log(nbResponse);
              //paymentMethod(payment2);
              //return false;                    
          }
        });
      }else if(this.fcRunway.value == "1"){
        this.paymentService.payByTodito(data).subscribe(result => {
          this.isBlocked = false;
          if(result.estatus == 0){
            window.location.href = result.msgError;
          }
        });
      }
    }else{
      this.toastr.error("Ocurrio un error al generar la cuenta por cobrar. Por favor intente nuevamente");
    }
  }

  isNullOrWhitespace( input ) {
    if (typeof input === 'undefined' || input == null) 
      return true;
    return input.replace(/\s/g, '').length < 1;
  }
}
